import React, { FC } from "react";

import { startOfMonth, endOfMonth } from "date-fns";

import {
  useApisAnalyticsPlansSalesConceptCategoriesIndex,
  useDateRange,
  useMultiDivisionMultiSectionDropdown,
  useProvidersCurrentEmployee,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { AnalyticsPlansCountDisplayBoxes } from "~/components/organisms";

const today = new Date();

export const AnalyticsPlansSalesConceptCategoriesIndex: FC = () => {
  const { currentEmployee } = useProvidersCurrentEmployee();

  const breadCrumbItems = [
    {
      label: "ブログ分析",
      href: "/analytics_plans/sales_concept_categories",
    },
  ];

  const {
    selectableDivisions,
    selectedDivisions,
    onDivisionChange,
    optionSelectableSections,
    optionSelectedSections,
    onSectionChange,
  } = useMultiDivisionMultiSectionDropdown({
    selectableDivisions: currentEmployee?.businessDivisions,
    selectableSections: currentEmployee?.businessSections,
  });

  const [
    {
      startDate,
      formattedStartDate,
      endDate,
      formattedEndDate,
      onChange: onChangeDateRange,
    },
  ] = useDateRange([startOfMonth(today), endOfMonth(today)]);

  const { data, isLoading } = useApisAnalyticsPlansSalesConceptCategoriesIndex({
    params: {
      businessDivisionIds: selectedDivisions.map((division) => division.id),
      businessSectionIds: optionSelectedSections.map((section) => section.id),
      fromDate: formattedStartDate || undefined,
      toDate: formattedEndDate || undefined,
    },
    config: {
      enabled: !!(formattedStartDate && formattedEndDate),
    },
  });

  return (
    <>
      <EmployeeLayout
        withRightSidebar={false}
        breadCrumbItems={breadCrumbItems}
      >
        <EmployeeLayoutMainContent withRightSidebar={false}>
          <AnalyticsPlansCountDisplayBoxes
            selectableDivisions={selectableDivisions}
            selectedDivisions={selectedDivisions}
            onDivisionChange={onDivisionChange}
            optionSelectableSections={optionSelectableSections}
            optionSelectedSections={optionSelectedSections}
            onSectionChange={onSectionChange}
            startDate={startDate}
            endDate={endDate}
            onChangeDateRange={onChangeDateRange}
            data={
              data
                ? {
                    managersPostsCount: data.managersPostsCount,
                    ownersPostsCount: data.ownersPostsCount,
                    others: [
                      {
                        count: data.postsPageViewsCount,
                        title: "ページビュー数",
                      },
                    ],
                  }
                : undefined
            }
            rankings={[
              {
                title: "ユーザー別ページビュー数",
                data: data?.postsPageViewsEmployeesRankings,
              },
              {
                title: "ブログ別ページビュー数",
                data: data?.postsPageViewsSalesConceptsRankings,
              },
            ]}
            isLoading={isLoading}
          />
        </EmployeeLayoutMainContent>
      </EmployeeLayout>
    </>
  );
};
